import React, { useEffect, useState } from 'react';
import { listDatasets } from 'features/datasets/api/datasetsApi';

/**
 * The dataset a step reads or writes: one of the team's, or (allowNew, the
 * Add rows step) a name typed here, created on the agent's first run like the
 * SDK's append. Stores an id when one is picked, the raw name otherwise.
 */
export default function DatasetPicker({ value, onChange, invalid = false, allowNew = true }) {
  const [datasets, setDatasets] = useState(null);
  useEffect(() => {
    let off = false;
    Promise.resolve(listDatasets()).then((d) => { if (!off) setDatasets(d || []); }).catch(() => { if (!off) setDatasets([]); });
    return () => { off = true; };
  }, []);
  const ids = new Set((datasets || []).map((d) => String(d.id)));
  const isId = value && ids.has(String(value));
  return (
    <div className="flex flex-col gap-1.5">
      <select
        aria-label="Dataset"
        value={isId ? String(value) : ''}
        onChange={(e) => onChange(e.target.value)}
        className={`h-8 w-full rounded-md border bg-[color:var(--surface-base)] px-2 text-[12px] text-[color:var(--text-primary)] outline-none ${invalid ? 'border-[color:var(--feedback-error)]' : 'border-[color:var(--border-default)]'}`}
      >
        <option value="">{datasets === null ? 'Loading datasets…' : 'Choose a dataset'}</option>
        {(datasets || []).map((d) => <option key={d.id} value={d.id}>{d.name}{d.item_count != null ? ` · ${Number(d.item_count).toLocaleString()} rows` : ''}</option>)}
      </select>
      {allowNew && <input
        aria-label="Or a new dataset name"
        value={isId ? '' : (value || '')}
        onChange={(e) => onChange(e.target.value)}
        placeholder="…or type a name to create one on the first run"
        className="h-8 w-full rounded-md border border-[color:var(--border-default)] bg-[color:var(--surface-base)] px-2 text-[12px] text-[color:var(--text-primary)] outline-none placeholder:text-[color:var(--text-disabled)]"
      />}
    </div>
  );
}
